import type { ColumnDef } from '@tanstack/react-table';
import type { SageDetailsRow } from '../../../services/sage.service';
import { formatCurrency } from '../../../utils/money';

type Col = ColumnDef<SageDetailsRow>;
const money = (accessorKey: string, header: string): Col => ({
  accessorKey, header, size: 140,
  cell: ({ getValue }) => formatCurrency(getValue()), meta: { aggType: 'sum' },
});
const txt = (accessorKey: string, header: string, size = 150): Col => ({ accessorKey, header, size });

/**
 * V1 reports_cms.pl:2820–2846, column for column. `description` is the PRO NUMBER —
 * which on a storage line is the storage due date, because that is what V1's export
 * query selects into its pronumber column.
 */
export const sageDetailsColumns: Col[] = [
  { accessorKey: 'invoicedate', header: 'Invoice Date', size: 130, meta: { isDate: true, showTime: false } },
  txt('mas90code', 'Bill To', 120),
  txt('cname', 'Bill To Name', 240),
  txt('invoicenum', 'Invoice #', 130),
  money('invoicesubtotal', 'Invoice Subtotal'),
  money('invoicetotal', 'Invoice Total'),
  txt('glcode', 'GL Code', 130),
  txt('description', 'Pro Number', 130),
];
